import { useApi2call } from 'containers/Api2/index.js';

function useDeleteMeetings() {
  const api2call = useApi2call();

  function callDelete(url, options) {
    return api2call({
      method: 'DELETE',
      url,
      withPromise: true,
      ...options,
    });
  }

  const deleteMeetingSet = (setId, options) => callDelete(`meetings/sets/${setId}`, options);
  const deleteBlock = (setId, blockId, options) => callDelete(`meetings/sets/${setId}/blocks/${blockId}`, options);
  const deleteMeeting = (setId, meetingId, options) => callDelete(`meetings/sets/${setId}/meetings/${meetingId}`, options);
  const deleteTimeslot = (setId, slotId, options) => callDelete(`meetings/sets/${setId}/timeslots/${slotId}`, options);

  return { deleteMeetingSet, deleteBlock, deleteMeeting, deleteTimeslot };
}

export default useDeleteMeetings;
